/* eslint-disable react/jsx-no-bind */
import React from 'react';
import '../../www/assets/css/video_controls.css';
import CloseButtonSVG from '../../www/assets/images/close-x.svg';
import PauseButtonSVG from '../../www/assets/images/pause_solid.svg';
import PlayButtonSVG from '../../www/assets/images/play_solid.svg';
import LeftButtonSVG from '../../www/assets/images/chevron_left.svg';
import { refsStore, videoStore } from '../managers/globalState';
import BackButton from './back_button';


class VideoControls extends React.PureComponent {
/**
 * @param {HTMLDivElement} div
 */
	constructor(props) {
		super(props);

		this.props = props;
		this._pauseIcon = <PauseButtonSVG className='play-pause-icon' />;
		this._playIcon = <PlayButtonSVG className='play-pause-icon' />;
		const { get } = refsStore.stateSnapshot;
		this.videoManager = get('video');

		this.state = {
			playPauseIcon: null,
			videoLoading: false
		};

		this.close = this.close.bind(this);
		this.back = this.back.bind(this);
		this.togglePlayPause = this.togglePlayPause.bind(this);
		this.openChartOverlay = this.openChartOverlay.bind(this);
	}

	componentDidMount() {
		this.videosUnsubscribe = videoStore.subscribeTo('isVideoPlaying', isVideoPlaying => {
			const playPauseIcon = isVideoPlaying ? this._pauseIcon : this._playIcon;
			this.setState({ playPauseIcon: playPauseIcon });
		});
		this.videosLoadingUnsubscribe = videoStore.subscribeTo('isVideoLoading', isVideoLoading => {
			this.setState({ videoLoading: isVideoLoading });
		});
	}

	componentWillUnmount() {
		typeof this.videosUnsubscribe === 'function' && this.videosUnsubscribe();
		typeof this.videosLoadingUnsubscribe === 'function' && this.videosLoadingUnsubscribe();
	}

	async back() {
		const { get } = refsStore.stateSnapshot;
		get('camera').offsetPioneerViewportLeft(0);
		videoStore.setGlobalState({ videoId: null });
		const { isMobile } = this.props;

		// Handle mobile back button logic to return to the overlay that loaded this Chart/Modal video
		// The back button is only available on Charts & Modal videos in mobile.
		if (isMobile) {
			const { videoOpenedFrom } = videoStore.stateSnapshot;
			if (videoOpenedFrom === 'mobileVSOverlay') {
				const { setOverlayType } = this.props;
				await setOverlayType('vitals', false);
			} else if (videoOpenedFrom === 'mobileDetailsOverlay') {
				const { detailOverlayRef } = this.props;
				await detailOverlayRef.current.toggle();
			}
		}

		// Reset where this Chart/Modal Video was called from.
		videoStore.setGlobalState({ videoOpenedFrom: null });
		this.videoManager.setVideoQuery(null);
	}

	async close() {
		const { get } = refsStore.stateSnapshot;
    const { videoOpenedFrom } = videoStore.stateSnapshot;
		videoStore.setGlobalState({ videoOpenedFrom: null });
		videoStore.setGlobalState({ videoId: null });

		const routeManager = get('route');
    routeManager.navigate(routeManager.history.location.pathname + routeManager.history.location.search.replace(/&videoId=\d+/, ''))
	}

	resetPlayIcon() {
		this.setState({ playPauseIcon: this._playIcon });
	}

	togglePlayPause() {
		// Pause/Play video
		this.videoManager.toggleVideoPlayPause();
	}

	/**
 * Open full screen overlay featuring the chart that was clicked.
 */
	openChartOverlay() {
		const { isMobile } = this.props;
		if (isMobile) {
			return;
		}
		this.props.setOverlayType('chart');
	}

	render() {
		const { isMobile } = this.props;
		const { get } = refsStore.stateSnapshot;
		const { videoId } = videoStore.stateSnapshot;
		const video = this.videoManager.getVideo(videoId);
		const { playPauseIcon, videoLoading } = this.state;

		if (video === null) {
			return null;
		}

		let globalMobileDateRange = '';
		if ((video.type === 'global' || video.type === 'geoLocated') && video.mobileDateRange) {
			globalMobileDateRange = 'Range: ' + video.mobileDateRange;
		}

		if (video === null || video === undefined) {
			const route = get('route');
			route.navigate(route.removeQuery(['videoId']));
			return null;
		}

		if (video.type === 'modal' || video.type === 'static') {
			return (
				<div className='video-overlay-container scrollable'>
					{!isMobile
				&& (
					<div className='close-button clickable' onClick={this.close}>
						<CloseButtonSVG className='close-icon' />
					</div>
				)}
					{isMobile
				&& (
					<div className='modal-mobile-header'>
						<div className='mobile-back-button clickable' onClick={this.back}>
							<LeftButtonSVG className='left-icon' />
						</div>
						<h2 className='mobile-title'>
							{video.title}
							{' '}
						</h2>
						<div className='mobile-close-button clickable' onClick={this.close}>
							<CloseButtonSVG className='close-icon' />
						</div>
					</div>
				)}
					<div className='video-overlay scrollable'>
						{ video.type === 'modal' && (
							<video
								className='video clickable'
								controls
								src={video.src}
								autoPlay
								loop
								muted
								width='100%'
								// Consider adding backup video types if we ever use something other than mp4 files.
								type='video/mp4'
							/>
						)}
						{ video.type === 'static' && (
							<img
								className='video-static clickable'
								src={video.src}
								alt={video.alt_text}
								width='100%'
								onClick={this.openChartOverlay}
							/>
						)}
						{ !isMobile && (
							<h2 className='video-title'>
								{video.title}
							</h2>
						)}
						<p className='video-description content scrollable'>
							{ video.description ? video.description : null }
						</p>
					</div>
				</div>
			);
		} else if (video.type === 'global' || video.type === 'geoLocated') {
			return (
				<>
					{isMobile
			&& (
				<div id='mobile-video-overlay-container-show' className='global-video-overlay-container'>
					{ !videoLoading && playPauseIcon && (
						<span className='global-video-date-button-container'>
							<button className='play-pause-button clickable' onClick={this.togglePlayPause}>
								{playPauseIcon}
							</button>
							<span className='global-mobile-date-range'>{globalMobileDateRange}</span>
						</span>
					)}
				</div>
			)}
					{!isMobile
				&& (
					<>
						<BackButton customOnClick={this.close} />
						{ !videoLoading && playPauseIcon && (
							<button className='play-pause-button clickable' onClick={this.togglePlayPause}>
								{playPauseIcon}
							</button>
						)}
					</>
				)}
				</>
			);
		}
	}
}

export default VideoControls;
